import { themeColorSet, ThemedView } from '@app/theme';
import {
  CheckCircleIcon,
  XIcon,
  CaretUpIcon,
  CaretDownIcon,
  CaretLeftIcon,
  ArrowLeftIcon,
  CaretRightIcon,
  ArrowUpRightIcon,
  ArrowDownLeftIcon,
  WarningIcon,
  WarningCircleIcon,
  RadioButtonIcon,
  CircleIcon,
  InfoIcon,
  ArrowsCounterClockwiseIcon,
  CaretCircleRightIcon,
  ClockCounterClockwiseIcon,
  PlusIcon,
  MinusIcon,
  FunnelSimpleIcon,
  MagnifyingGlassIcon,
  PencilSimpleIcon,
  ArrowsLeftRightIcon,
  ClockIcon,
  ArrowDownIcon,
  ArrowUpIcon
} from '@phosphor-icons/react';

const DebitIcon = ()=>(<ThemedView p="sm" borderRadius='full' justifyContent='center' alignItems='center' borderWidth={1}  borderColor='border-secondary'>
    <ArrowUpRightIcon size={20} color={themeColorSet['icon-primary']} />
</ThemedView>
)

const CreditIcon = ()=>(
<ThemedView p="sm" borderRadius='full' justifyContent='center' alignItems='center' borderWidth={1}  borderColor='border-secondary'>
<ArrowDownLeftIcon size={20} color={themeColorSet['icon-primary']} />
</ThemedView>)

export {
  CheckCircleIcon as CheckCircle,
  XIcon as X,
  CaretUpIcon as CaretUp,
  CaretDownIcon as CaretDown,
  CaretLeftIcon as CaretLeft,
  ArrowLeftIcon as ArrowLeft,
  ArrowUpRightIcon as ArrowUpRight,
  ArrowDownLeftIcon as ArrowDownLeft,
  WarningIcon as Warning,
  WarningCircleIcon as WarningCircle,
  InfoIcon as Info,
  RadioButtonIcon as RadioButton,
  CircleIcon as Circle,
  CaretRightIcon as CaretRight,
  ArrowsCounterClockwiseIcon as ArrowsCounterClockwise,
  DebitIcon,
  CreditIcon,
  ClockCounterClockwiseIcon as ClockCounterClockwise,
  PlusIcon as Plus,
  MinusIcon as Minus,
  FunnelSimpleIcon as FunnelSimple,
  MagnifyingGlassIcon as MagnifyingGlass,
  PencilSimpleIcon as PencilSimple,
  CaretCircleRightIcon as CaretCircleRight,
  ArrowsLeftRightIcon as ArrowsLeftRight,
  ClockIcon as Clock,
  ArrowDownIcon as ArrowDown,
  ArrowUpIcon as ArrowUp,
};

